export default {
  ABOUT_US: 'aboutUs',
  ATTORNEY_PROFILE: 'attorneyProfile',
  CHAT_WIDGET: 'chatWidget',
  CITY_PAGE: 'cityPage',
  CTA_COVER: 'ctaCover',
  CTA_FACEBOOK_GROUP: 'ctaFacebookGroup',
  CTA_FAMOUS_DEBTORS: 'ctaFamousDebtors',
  CONTENT_TEXT: 'contentText',
  HEADER_HELLO_BAR: 'headerHelloBar',
  HEADER_NAV: 'headerNav',
  HEADER_MOBILE_FOOTER: 'headerMobileFooter',
  HOME_PAGE_HERO: 'homePageHero',
  HOME_PAGE_VALUE_PROPS: 'homePageValueProps',
  INSERT: 'insert',
  NEWSLETTER_POPUP: 'newsletterPopup',
  PAGE_NOT_FOUND: 'pageNotFound',
  SIDEBAR_CTA: 'sidebarCta',
  SIDEBAR_HERO: 'sidebarHero',
  SIDE_BY_SIDE_OFFERINGS: 'sideBySideOfferings',
  STATE_PAGE: 'statePage',
  TESTIMONIAL: 'testimonial',
  UPSOLVE_FILERS_COUNT: 'upsolveFilersCount',
};
